import { createAsyncThunk } from '@reduxjs/toolkit';
import qs from 'qs';
import Config from 'config';
import {
  TAsyncThunkState,
  ILoadStructureProps,
  TTableStructure,
} from '../../../types';
import ApiaApi from '../../../../../api/apiaApi/apiaApi';
import { TApiaFinderStructureResponse } from '../../../../../components/apia/execution/fields/apiaFinder/types';
import { arrayOrArray } from '../../../../../utils/util';
import store from '../../../..';
import { responsiveTableActions } from '../../../../responsiveTableSlice';
import { getCurrentListId } from '../../../../../components/apia/common/lists/hooks/useCurrentListId';
import { buttonsActions } from '../../../../buttonsSlice';
import { TQueriesActionsChain } from '../../../queueController';

const loadSavedFilters = createAsyncThunk<
  TTableStructure | null,
  { fieldId: string; queueKey?: TQueriesActionsChain } & ILoadStructureProps,
  TAsyncThunkState
>(
  'querySlice/loadSavedFilters',
  async (
    {
      fieldId,
      action = 'executeUserQryFiltersEvents',
      payload,
      method = 'GET',
      query = {},
    },
    thunkApi,
  ) => {
    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: true,
          action: 'disableTable',
        },
      ]),
    );
    console.log(query);

    const state = thunkApi.getState().querySlice.queries[fieldId];

    let queryString = qs.stringify({
      ...(action !== null ? { action } : {}),
      ...query,
      query: state.queryData?.qryId,
    });
    if (queryString.length > 0) queryString = `&${queryString}`;
    const url = `${Config.FINDER_FIRST_STRUCTURE_LOAD(
      state.ajaxUrl,
    )}${queryString}`;

    let result;

    switch (method) {
      case 'GET':
        // This method will be used on first load and while sorting
        result = await ApiaApi.get<TApiaFinderStructureResponse>(url, {
          notificationsCategory: 'apiaFinder',
        });

        break;
      case 'POST':
        // This method will be used on search
        result = await ApiaApi.post<TApiaFinderStructureResponse>(url, {
          ...{ notificationsCategory: 'apiaFinder' },
          postData: qs.stringify(payload),
        });
        break;
      default:
        throw new Error('Unexpected method');
    }

    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: false,
          action: 'disableTable',
        },
      ]),
    );

    if (result && result.data) {
      store.dispatch(
        responsiveTableActions.update({
          tableName: getCurrentListId(),
          selectedRows: [],
        }),
      );

      return {
        columns: arrayOrArray(result.data.columns.column),
        filters: {
          filter: arrayOrArray(result.data.filters.filter),
          hideFilterTypes: result.data.filters.hideFilterTypes,
          openFiltersAutomatically:
            result.data.filters.openFiltersAutomatically,
          runFiltersAutomatically: result.data.filters.runFiltersAutomatically,
        },
        queryData: result.data.queryData,
      };
    }
    throw new Error();
  },
);

export default loadSavedFilters;
